/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerSchedulesInner } from './GetProducts200ResponseItemsInnerSchedulesInner';
import {
    GetProducts200ResponseItemsInnerSchedulesInnerFromJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerSchedulesInnerToJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerSchedulesInner';
import type { GetProducts200ResponseItemsInnerInformation } from './GetProducts200ResponseItemsInnerInformation';
import {
    GetProducts200ResponseItemsInnerInformationFromJSON,
    GetProducts200ResponseItemsInnerInformationFromJSONTyped,
    GetProducts200ResponseItemsInnerInformationToJSON,
    GetProducts200ResponseItemsInnerInformationToJSONTyped,
} from './GetProducts200ResponseItemsInnerInformation';

/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInner
 */
export interface GetProducts200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProducts200ResponseItemsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInner
     */
    price: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProducts200ResponseItemsInner
     */
    modifierGroups: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetProducts200ResponseItemsInner
     */
    hasSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProducts200ResponseItemsInner
     */
    controlEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    kitchenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    course?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInner
     */
    taxCategories?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProducts200ResponseItemsInner
     */
    allergens?: Array<GetProducts200ResponseItemsInnerAllergensEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProducts200ResponseItemsInner
     */
    specifications?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProducts200ResponseItemsInner
     */
    additives?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetProducts200ResponseItemsInner
     */
    isPrepackaged?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProducts200ResponseItemsInner
     */
    allowDecimalQuantity: boolean;
    /**
     * 
     * @type {GetProducts200ResponseItemsInnerInformation}
     * @memberof GetProducts200ResponseItemsInner
     */
    information: GetProducts200ResponseItemsInnerInformation | null;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerSchedulesInner>}
     * @memberof GetProducts200ResponseItemsInner
     */
    schedules?: Array<GetProducts200ResponseItemsInnerSchedulesInner>;
}


/**
 * @export
 */
export const GetProducts200ResponseItemsInnerAllergensEnum = {
    Gluten: 'gluten',
    Crustaceans: 'crustaceans',
    Eggs: 'eggs',
    Fish: 'fish',
    Peanuts: 'peanuts',
    Soy: 'soy',
    Milk: 'milk',
    TreeNuts: 'tree-nuts',
    Celery: 'celery',
    Mustard: 'mustard',
    Sesame: 'sesame',
    Sulfites: 'sulfites',
    Lupin: 'lupin',
    Molluscs: 'molluscs'
} as const;
export type GetProducts200ResponseItemsInnerAllergensEnum = typeof GetProducts200ResponseItemsInnerAllergensEnum[keyof typeof GetProducts200ResponseItemsInnerAllergensEnum];


/**
 * Check if a given object implements the GetProducts200ResponseItemsInner interface.
 */
export function instanceOfGetProducts200ResponseItemsInner(value: object): value is GetProducts200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('modifierGroups' in value) || value['modifierGroups'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    if (!('controlEnabled' in value) || value['controlEnabled'] === undefined) return false;
    if (!('allowDecimalQuantity' in value) || value['allowDecimalQuantity'] === undefined) return false;
    if (!('information' in value) || value['information'] === undefined) return false;
    return true;
}

export function GetProducts200ResponseItemsInnerFromJSON(json: any): GetProducts200ResponseItemsInner {
    return GetProducts200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'price': json['price'],
        'modifierGroups': json['modifierGroups'],
        'hasSchedule': json['hasSchedule'],
        'controlEnabled': json['controlEnabled'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'color': json['color'] == null ? undefined : json['color'],
        'course': json['course'] == null ? undefined : json['course'],
        'taxCategories': json['taxCategories'] == null ? undefined : json['taxCategories'],
        'allergens': json['allergens'] == null ? undefined : json['allergens'],
        'specifications': json['specifications'] == null ? undefined : json['specifications'],
        'additives': json['additives'] == null ? undefined : json['additives'],
        'isPrepackaged': json['isPrepackaged'] == null ? undefined : json['isPrepackaged'],
        'allowDecimalQuantity': json['allowDecimalQuantity'],
        'information': GetProducts200ResponseItemsInnerInformationFromJSON(json['information']),
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerFromJSON)),
    };
}

export function GetProducts200ResponseItemsInnerToJSON(json: any): GetProducts200ResponseItemsInner {
    return GetProducts200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerToJSONTyped(value?: GetProducts200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'price': value['price'],
        'modifierGroups': value['modifierGroups'],
        'hasSchedule': value['hasSchedule'],
        'controlEnabled': value['controlEnabled'],
        'description': value['description'],
        'imageId': value['imageId'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'color': value['color'],
        'course': value['course'],
        'taxCategories': value['taxCategories'],
        'allergens': value['allergens'],
        'specifications': value['specifications'],
        'additives': value['additives'],
        'isPrepackaged': value['isPrepackaged'],
        'allowDecimalQuantity': value['allowDecimalQuantity'],
        'information': GetProducts200ResponseItemsInnerInformationToJSON(value['information']),
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerToJSON)),
    };
}

